import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useFlagIdentity } from "@athena/config/flags";
import { CurrentUserDocument } from "@/graphql/auth.generated";

/**
 * Re-targets LaunchDarkly once Auth0 resolves a signed-in operator.
 *
 * The provider in `main.tsx` is built before Auth0 has answered, so its first evaluation is
 * anonymous. Without this step it stayed anonymous for the whole session: no user, no
 * organization, so every organization-targeted flag fell through to its default rule and read as
 * off. Mobile has had this since the flags were wired (`apps/mobile/src/app/_layout.tsx`); web and
 * admin exported `useFlagIdentity` and never called it.
 *
 * Renders nothing, and must sit inside both the Auth0 and Apollo providers — it needs the one for
 * the user and the other for their organization. Keyed on the first membership, matching
 * `contextFor` on the server so a multi-org user resolves the same way on both sides.
 */
export function FlagIdentitySync() {
    const { user } = useAuth0();
    const { data } = useQuery(CurrentUserDocument, { skip: !user });
    useFlagIdentity({
        userId: data?.currentUser?.id,
        organizationId: data?.currentUser?.memberships[0]?.organization.id,
    });
    return null;
}
